module.exports = __webpack_public_path__ + "img/FR.9469089f.svg";